module.exports = __webpack_public_path__ + "static/media/SE.631a803f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/SE.svg
// module id = 355
// module chunks = 0